import React from "react";
import { Link } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";

export default function Footer() {
  return (
    <Navbar bg="dark" variant="dark">
      <Nav>
        <Nav.Link
          href="https://canonau.atlassian.net/projects/M2/issues"
          target="_blank"
          rel="noopener noreferrer"
        >
          Support
        </Nav.Link>

        <Nav.Link as={Link} to="/terms-and-conditions">
          Terms and Conditions
        </Nav.Link>

        <Nav.Link as={Link} to="/privacy-policy">
          Privacy Policy
        </Nav.Link>
      </Nav>
      <Nav className="ml-auto">
        <Nav.Link
          href="http://canon.com.au/"
          target="_blank"
          rel="noopener noreferrer"
        >
          © {new Date().getFullYear()} Canon Australia Pty Ltd
        </Nav.Link>
      </Nav>
    </Navbar>
  );
}
